import React from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
// import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
// import { FormattedMessage } from 'react-intl';
import UserDetails from "../UserDetails";

const ArchiveHeader = ({ title, back, save, intl, locale, setLocale }) => {
  let history = useHistory();
  return (
    <Container fluid className="pad-0">
      <Row className="no-gutters user-details-cont">
        <Col>
          {/* <h6>
            <FormattedMessage id={title} />
          </h6> */}
        </Col>
        <Col md={7}>
          <div className="text-right">
            {
              back &&  <div className="fixed-btn-set">
                <Button onClick={() => history.goBack()} className={`${save ? 'save-return' : ''} return`}>retour</Button>
              {
                save && <Button type="submit">Sauvegarder</Button>
              }
            </div>
            }
            <UserDetails ibtl={intl} locale={locale} setLocale={setLocale} />
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default ArchiveHeader;